module.exports = {
          srcSet: __webpack_public_path__ + "private/c7cc21605446e4527267c1bd0e4441c9-1.png"+" 1w",
          images:[ {path: __webpack_public_path__ + "private/c7cc21605446e4527267c1bd0e4441c9-1.png",width: 1,height: 1}],
          src: __webpack_public_path__ + "private/c7cc21605446e4527267c1bd0e4441c9-1.png",
          toString:function(){return __webpack_public_path__ + "private/c7cc21605446e4527267c1bd0e4441c9-1.png"},
          
          width: 1,
          height: 1
        }